/* Manual priorities followed by Shopify related products, refreshed from the actual cart. */
(function () {
  var versions = new WeakMap();
  var cartRevision = 0;
  function unique(ids) { return Array.from(new Set(ids.map(String))); }
  // Keep recommendation selection deterministic: manual first, then round-robin across cart items.
  function choose(manual, groups, cartIds, limit) {
    var seen = new Set(cartIds.map(String));
    var result = [];
    function add(candidate) {
      var id = candidate && candidate.id;
      if (!id || seen.has(String(id)) || result.length >= limit) return;
      seen.add(String(id)); result.push(candidate);
    }
    manual.forEach(add);
    var length = groups.reduce(function (max, group) { return Math.max(max, group.length); }, 0);
    for (var index = 0; index < length && result.length < limit; index++) {
      groups.forEach(function (group) { add(group[index]); });
    }
    return result;
  }
  function candidate(node) { return { id: node.dataset.ggAddonProduct, node: node }; }
  function render(root, candidates) {
    var grid = root.querySelector('[data-gg-addon-grid]');
    grid.replaceChildren.apply(grid, candidates.map(function (entry) { return entry.node.cloneNode(true); }));
    root.hidden = candidates.length === 0 && !window.Shopify?.designMode;
    var controls = root.querySelector('.gg-cart-addons__controls');
    if (controls) controls.hidden = candidates.length < 2;
  }
  async function update(root, ids) {
    var version = (versions.get(root) || 0) + 1;
    versions.set(root, version);
    var cartIds = unique(ids);
    var limit = Math.min(12, Math.max(1, Number(root.dataset.ggLimit) || 12));
    var manual = Array.from(root.querySelectorAll('template[data-gg-addon-manual]')).map(function (template) {
      return candidate(template.content.querySelector('[data-gg-addon-product]'));
    });
    if (!cartIds.length) { render(root, []); return; }
    render(root, choose(manual, [], cartIds, limit));
    if (root.dataset.ggAuto !== 'true' || choose(manual, [], cartIds, limit).length >= limit) return;
    var base = window.Shopify?.routes?.root || '/';
    var groups = new Array(cartIds.length).fill(null).map(function () { return []; });
    var next = 0;
    // Bound concurrent requests while considering every distinct product in the cart.
    async function worker() {
      while (next < cartIds.length) {
        if (!root.isConnected || versions.get(root) !== version) return;
        var index = next++;
        try {
          var url = base + 'recommendations/products?section_id=geekery-cart-related&product_id=' + encodeURIComponent(cartIds[index]) + '&limit=10&intent=related';
          var response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) continue;
          var html = await response.text();
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          groups[index] = Array.from(parsed.querySelectorAll('[data-gg-addon-product]')).map(candidate);
        } catch (error) { /* Retain manual picks and any other successful recommendations. */ }
      }
    }
    await Promise.all(Array.from({ length: Math.min(4, cartIds.length) }, worker));
    if (!root.isConnected || versions.get(root) !== version) return;
    render(root, choose(manual, groups, cartIds, limit));
  }
  function init(scope) {
    var roots = Array.from(scope.querySelectorAll('[data-gg-cart-addons]'));
    if (scope.matches?.('[data-gg-cart-addons]')) roots.unshift(scope);
    roots.forEach(function (root) {
      if (!root.dataset.ggNavigation) {
        root.dataset.ggNavigation = 'true';
        root.querySelector('[data-gg-addon-prev]').addEventListener('click', function () { root.querySelector('[data-gg-addon-grid]').scrollBy({ left: -root.querySelector('[data-gg-addon-grid]').clientWidth * .9, behavior: 'smooth' }); });
        root.querySelector('[data-gg-addon-next]').addEventListener('click', function () { root.querySelector('[data-gg-addon-grid]').scrollBy({ left: root.querySelector('[data-gg-addon-grid]').clientWidth * .9, behavior: 'smooth' }); });
      }
      var ids;
      try { ids = JSON.parse(root.dataset.ggCartProducts || '[]'); } catch (error) { ids = []; }
      update(root, ids);
    });
  }
  async function refresh() {
    var revision = ++cartRevision;
    var roots = Array.from(document.querySelectorAll('[data-gg-cart-addons]'));
    if (!roots.length) return;
    // Invalidate in-flight recommendations before retrieving newer cart contents.
    roots.forEach(function (root) { versions.set(root, (versions.get(root) || 0) + 1); });
    try {
      var response = await fetch((window.routes?.cartUrl || '/cart') + '.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      var cart = await response.json();
      if (revision !== cartRevision) return;
      var ids = cart.items.map(function (item) { return item.product_id; });
      document.querySelectorAll('[data-gg-cart-addons]').forEach(function (root) { update(root, ids); });
    } catch (error) { /* A failed refresh must not interfere with cart controls. */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  // Warehouse emits this event without bubbling on some cart paths; capture handles both.
  document.addEventListener('cart:rerendered', refresh, true);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
